import { Container } from "@pixi/react";
import React from "react";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import { PixiSettings } from "../../../../pixiSettings";
import { usePrimaryUIToolbarDimensionsV2 } from "../../../../Hooks/usePrimaryUIToolbarDimensionsV2";
import ButtonSound from "../Buttons/ButtonSound";
import ButtonMenu from "../Buttons/ButtonMenu";



const ToolbarBottomSecond = () => {
  const { dimensions, device, orientation } = useDimensions();
  const toolbar = usePrimaryUIToolbarDimensionsV2();

  // Only render on mobile portrait
  if (
    device !== PixiSettings.DEVICE.MOBILE ||
    orientation !== PixiSettings.ORIENTATION.PORTRAIT
  ) {
    return null;
  }

  return (
    <Container
      name="secondary_toolbar_bottom_second"
      x={(dimensions.width - toolbar.width) / 2}
      y={dimensions.height - toolbar.height}
      zIndex={10}
    >
      {/* Background is rendered by ToolbarBackgrounds (behind game layer) */}

      {/* Sound button — left side */}
      <ButtonSound toolbar={toolbar} />

      {/* Menu button — right side */}
      <ButtonMenu toolbar={toolbar} />
    </Container>
  );
};

export default ToolbarBottomSecond;
